import React from 'react'
import { IFaq } from '@et/types/Courses'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { FaqAnswer, faqAnswerVariants, FaqCloseBtn } from '@styles/modules/faqItemStyles'

interface IProps {
  textColor: string | undefined
  textActivatedColor: string | undefined
  itemIndex: number
  selectedItem: number | null
  handleClick: (itemIndex?: number | null) => void
  activeBgColor?: string
}

function FaqItem (props: IProps & IFaq) {
  const { activeBgColor, handleClick, itemIndex, selectedItem, question, answer, textColor, textActivatedColor } = props

  function click (e: any) {
    e.preventDefault()
    const element = e.target.tagName.toLowerCase()

    if (itemIndex === selectedItem && element === 'span') {
      handleClick()
    } else {
      handleClick(itemIndex)
    }
  }

  return (
    <FAQItem
      activeBgColor={activeBgColor}
      textActivatedColor={textActivatedColor}
      textColor={textColor}
      onClick={click}
      isOpen={itemIndex === selectedItem}>
      <h3>
        {question}
        <FaqCloseBtn isOpen={itemIndex === selectedItem} onClick={click}/>
      </h3>
      <FaqAnswer
        className={'answer-framer-motion'}
        textactivatedcolor={textActivatedColor}
        textcolor={textColor}
        isopen={itemIndex === selectedItem ? 'true' : 'false'}
        variants={faqAnswerVariants}
        animate={itemIndex === selectedItem ? 'open' : 'closed'}
      >
        {answer}
      </FaqAnswer>
    </FAQItem>
  )
}

interface IFAQItem {
  isOpen: boolean
  textActivatedColor: string | undefined
  textColor: string | undefined
  activeBgColor: string | undefined
}

const FAQItem = styled.div<IFAQItem>`
  padding: 40px 0 25px;
  border-bottom: 1px solid ${props => props.theme.lineColor};
  cursor: pointer;
  background: ${props => props.isOpen
  ? props.activeBgColor
    ? props.activeBgColor : props.theme.highlight.i500
  : 'transparent'};
  transition: .3s;
  
  h3{
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    padding: ${props => props.isOpen ? '0 40px 0 20px' : '0 40px 0 0'};
    color:${props => props.textColor
  ? props.isOpen
    ? props.textActivatedColor
    : props.textColor
  : props.theme.headlineColor};
    transition: .3s;
    margin-bottom: 15px;
    margin-right: 25px;
    position: relative;
   
    @media ${device.tablet}{
      font-size: 21px;
      max-width: 750px;
    }
  }
  
  @media ${device.laptop}{
    &:hover{ 
      h3{
        padding-left: 20px;
        color: ${props => props.isOpen
  ? props.textColor ? props.textActivatedColor : props.theme.headlineColor
  : props.theme.highlight.i500};
      }
    }
  }
  
`
export default FaqItem
